/* DON'T EDIT THIS FILE: edit original and run build again */ export enum BalanceSheetSortOrder {
  oldToNew = "oldToNew",
  newToOld = "newToOld",
}

export const balanceSortingOptions = {
  [BalanceSheetSortOrder.oldToNew]: "Del viejo al nuevo",
  [BalanceSheetSortOrder.newToOld]: "Del nuevo al viejo",
};
